export default __webpack_public_path__ + "static/media/background-mobile.178d8c44.svg";